import { collectionsmap } from 'data/collections'
import styled from 'styled-components'

const WrongItem = ({
  item,
  user,
  colorMode,
}: {
  item: Item
  user: Answer
  colorMode: 'light' | 'dark' | undefined
}) => {
  if (!item) return null
  return (
    <WrongItemContainer
      style={{
        backgroundColor:
          colorMode === 'light'
            ? 'var(--beige-bright-3)'
            : 'var(--petrol-dark-1)',
      }}
    >
      {item.image && (
        <ImageContainer>
          <ItemImage
            src={require(`../../../images/Products/${item.image}_red.png`)}
          />
        </ImageContainer>
      )}
      {!item.image && (
        <ImageContainer>
          <ItemImage
            src={require(`../../../images/Products/products_empty.png`)}
          />
        </ImageContainer>
      )}
      <div>
        {/* <Title>{item.name_de}</Title> */}
        <Text>
          <span>Sie {user.answer === 'separate' ? 'müssen' : 'sollten'} </span>
          <b>
            {item.unbest_artikel_de} {item.name_de}
          </b>{' '}
          <span>
            {collectionsmap[user.answer].false_text_de} {item.correct_text_de}
          </span>
        </Text>
      </div>
    </WrongItemContainer>
  )
}
const WrongItemContainer = styled.div`
  color: var(--text-color);
  border-radius: 4px;
  /* width: 50%; */
  flex: 0 0 calc(50% - 50px);
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: flex-start;
  font-size: 18px;
  line-height: 1.6em;
  padding: 25px 20px;
  /* margin-bottom: 30px; */
  background-color: var(--beige-bright-3);
  /* color:var(--beige-dark-2) */
  /* display: block; */
  @media screen and (max-width: 711px) {
    flex: 0 0 calc(100% - 40px);
  }
`
const ImageContainer = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 10px;
  @media screen and (max-width: 711px) {
    margin-top: -10px;
  }
`
const ItemImage = styled.img`
  max-width: 100px;
  margin-right: 25px;

  @media screen and (max-width: 711px) {
    max-width: 80px;
  }
`

const Title = styled.div`
  font-weight: 700;
  font-size: 19px;
  line-height: 2em;
`
const Text = styled.div`
  height: 100%;
  /* display: flex; */
  line-height: 1.4em;
  font-size: 18px;
  b {
    font-size: 17.5px;
  }
  @media screen and (max-width: 711px) {
    font-size: 15px;
    line-height: 1.5em;
    b {
      font-size: 16px;
    }
  }
`
export default WrongItem
